import {dataSidebar} from "./dataSidebar";
import WebLogo from '../../font & image/image/favicon.png'
import {useLocation, useNavigate} from "react-router-dom";
import {useState} from "react";
import {IoIosArrowUp} from "react-icons/io";
import {IoIosArrowDown} from "react-icons/io";


export default function SideBar({setShowMenuMobile}) {

    const navigate = useNavigate();
    const location = useLocation();

    const [statusDrop, setStatusDrop] = useState("")


    function clickItem(value) {
        setStatusDrop(value.title)
        if (!value.subItem) {
            navigate(value.link)
            setShowMenuMobile?.(false)
        }
    }


    return (

        <div>

            <div className="flex items-center gap-3 justify-center">
                <img src={WebLogo} alt="goalafarin" className="w-[80%] p-4" height={42} width={42}/>
            </div>


            <ul className="flex flex-col gap-1 text-xl mt-3">
                {dataSidebar.map((item, index) =>
                    <li className={`flex flex-col py-2 px-5 gap-2  ${location.pathname === item.link ? "text-bg-secondColor-shade7 bg-white" : `text-white ${!item.subItem ? `hover:translate-x-3` : null}`} duration-500 hover:cursor-pointer`}
                        key={index}
                        onClick={() => clickItem(item)}
                    >
                        <div className="flex items-center">
                            <span
                                className={`flex gap-2 items-center w-full ${item.subItem ? ((statusDrop === item.title) && item.subItem) ? null : `duration-500 hover:translate-x-3` : null}`}>
                                {item.icon}
                                {item.title}
                            </span>

                                {item.subItem ?
                                    (((statusDrop === item.title) && item.subItem)) ?
                                        <IoIosArrowUp/>
                                        :
                                        <IoIosArrowDown/>
                                    :
                                    null
                                }
                            
                        </div>
                        {(((statusDrop === item.title) && item.subItem)) &&
                            <ul className="flex flex-col gap-1 text-xl">
                                {item.subItem.map(value =>
                                    <li className={`flex gap-2 text-[16px] rounded-lg duration-500  ${location.pathname === value.link ? "text-secondColor-shade7 bg-white" : `hover:translate-x-3 text-white`}`}
                                        key={item.link}
                                        onClick={() => {
                                            navigate(value.link);
                                            setShowMenuMobile?.(false)
                                        }}
                                    >
                                        <p className="px-8">{value.title}</p>
                                    </li>
                                )}
                            </ul>
                        }
                    </li>
                )}
            </ul>


        </div>
    )
}